import { render, staticRenderFns } from "./ZahnwerkstattJobsPage.vue?vue&type=template&id=70e80d7c&scoped=true"
import script from "./ZahnwerkstattJobsPage.vue?vue&type=script&lang=js"
export * from "./ZahnwerkstattJobsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e80d7c",
  null
  
)

export default component.exports